import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

import { Section, Title, Text, Span } from "../../components/Core";
import imgPhoto from "../../assets/image/png/fabio_palumbo.png";
import imgSignLight from "../../assets/image/png/signature.png";

const LinkSocial = styled.a`
  color: ${({ theme }) => theme.colors.light} !important;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 1.63px;
  transition: 0.4s;
  &:hover {
    color: ${({ theme }) => theme.colors.light} !important;
    transform: translateY(-5px);
  }
`;

const About = ({ hero = true, bg = "dark", ...rest }) => {
  return (
    <>
      <Section hero={hero} bg={bg} {...rest}>
        <Container>
          <Row className="align-items-center">
            <Col lg="6">
              <div>
                <img src={imgPhoto} alt="folio" className="img-fluid" />
              </div>
            </Col>
            <Col lg="6">
              <div className="pl-lg-4 pt-5 pt-lg-0">
                <Title color="light" variant="secSm">
                  Fabio Palumbo
                </Title>
                <Text
                  color="light"
                  className="mt-3 mt-lg-5"
                  css={`
                    line-height: 1.5;
                  `}
                >
                  Cloud Architect and CKA based in New York, USA. <br />
                  Always working with a minimal and simple design in mind.
                </Text>
                <Text color="light" className="mt-4">
                <b>Dioscuro</b> is a globally distributed team of experts specialized in DevOps and Cloud Services. <br /> Driven by our mission to empower businesses in navigating and mastering their infrastructure challenges, we have become a beacon for companies looking to scale, especially in dynamic sectors like web3, Fintech and e-commerce.
                </Text>
                <div className="mt-4">
                  <Text color="light">Email me at</Text>

                  <Text variant="p">
                    <a
                      href="mailto:hello@dioscuro.com"
                      className="font-weight-bold"
                    >
                      <Span color="light">hello@dioscuro.com</Span>
                    </a>
                  </Text>
                </div>
                <div className="mt-5">
                  <img src={imgSignLight} alt="sign" className="img-fluid" />
                </div>
                <Text color="light" className="mt-3 font-weight-bold">
                  Fabio Palumbo
                </Text>
                <Text color="light" variant="small">
                  Founder of Dioscuro LLC
                </Text>
                <div className="mt-5 d-flex">
                  <LinkSocial
                    href="https://www.linkedin.com/in/fppalumbo/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className=" mr-3"
                  >
                    Linkdin
                  </LinkSocial>
                  <br />
                  <LinkSocial
                    href="https://github.com/fabiopalumbo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className=" mr-3"
                  >
                    Github
                  </LinkSocial>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default About;
